import { SpaceProps, Table, TableContainer, Tbody, Td, Text, Tr } from "@chakra-ui/react";
import { ReactNode } from "react";

type BasicInfoListProps = {
  infos: { label: string; value: ReactNode }[];
  gap: NonNullable<SpaceProps["py"]>;
};

export const BasicInfoList = ({ infos, gap }: BasicInfoListProps) => {
  return (
    <TableContainer overflow="hidden" maxW="full">
      <Table layout="auto" variant="unstyled">
        <Tbody>
          {infos.map(({ label, value }) =>
            !value ? null : (
              <Tr maxW="full" key={label}>
                <Td verticalAlign="top" p={0} py={gap} pt={0} pr={2}>
                  <Text as="strong">{label}</Text>
                </Td>
                <Td p={0} py={gap} pt={0} whiteSpace="normal" wordBreak="break-word">
                  <Text>{value ?? "Onbekend"}</Text>
                </Td>
              </Tr>
            )
          )}
        </Tbody>
      </Table>
    </TableContainer>
  );
};
